package com.exura.features.plandefinition.data.remote.dto.element

import com.exura.features.plandefinition.domain.model.element.ElementType
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

/**
 * DTO for QuestionElement.
 * Extends BasePlanElementDto for Firebase storage compatibility.
 */
@Serializable
@SerialName("question_element")
data class QuestionElementDto(
    override val elementType: String = ElementType.QUESTION.name,
    override val durationInMinutes: Int,
    override val durationInDays: Int,
    val relativeDay: Int,
    val title: String,
    val question: String,
    val options: List<OptionDto>,
    override val imageUrl: String? = null
) : BasePlanElementDto() {

    @Serializable
    data class OptionDto(
        val id: String,
        val text: String,
        val responseMessage: String? = null
    )
}
